import { useState } from "react";

export const useStatusWebsocket = () => {
  const [ws, setWs] = useState<WebSocket | null>(null);
  const createWebsocket = (
    wsUri: string,
    onMessageCallback: (message: string) => void,
  ) => {
    const ws = new WebSocket(wsUri);
    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (!message) return;
      onMessageCallback(message);
    };
    setWs(ws);
  };

  const closeWebsocket = () => {
    if (ws) {
      ws.close();
    }
  };

  return {
    createWebsocket,
    closeWebsocket,
  };
};
